<!-- Software Release Life Cycle -->
<!-- Alpha > Beta > Stable Release(General Availability) -->
<template>
  <div class="fts-release-badge">{{badgeLabel}}</div>
</template>

<script>
export default {
  props: {
    badgeLabel: {
      type: String,
      default: 'Beta',
    },
  },
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-release-badge {
  display: inline-flex;
  padding: 0 .125rem;
  border-radius: 2px;
  background-color: var(--fts-dark);
  color: #fff;
  text-transform: uppercase;
  font-size: 10px;
  font-weight: 400;
  font-family: monospace;
  font-style: normal;
  white-space: normal;
  line-height: normal;
  letter-spacing: 0.25px;
  &.editor-tool-rb {
    position: absolute;
    top: -3px;
    right: 0;
  }
  &.control-modal-label-rb {
    height: 100%;
    margin-left: .375rem;
  }
}
</style>